import {
  buildFormValidate,
  required,
  validEmail,
} from "@turo/libraries/lib/helpers/validationHelpers";
import { recaptcha } from "@turo/libraries/lib/recaptcha/recaptcha";
import PropTypes from "prop-types";
import React, { Component } from "react";

import stateForm, {
  FIELD_TYPES,
  formFieldsPropertyType,
} from "../../components/stateForm";
import config from "../../config";
import { getPropertiesFromQuery, post } from "../../helpers/iframeHelpers";
import EmailLoginForm from "./EmailLoginForm";

class EmailLoginFormView extends Component {
  handleSubmit = this.props.buildSubmitHandler(({ email, password }) => {
    this.props.loginStart();
    return recaptcha
      .execute(recaptcha.ACTIONS.LOGIN, config.GOOGLE_CAPTCHA_SITE_KEY)
      .catch((error) => {
        this.props.loginFailure({ error: "error_generic" });
        throw error;
      })
      .then((token) =>
        post(
          "/api/login",
          { password, username: email },
          { [recaptcha.HEADER_NAME]: token }
        ).then((data) => {
          if (data.error) {
            this.props.loginFailure(data);
          } else {
            this.props.loginSuccess(data);
          }
        })
      );
  });

  static propTypes = {
    buildSubmitHandler: PropTypes.func.isRequired,
    formFields: formFieldsPropertyType.isRequired,
    isLoading: PropTypes.bool.isRequired,
    loginFailure: PropTypes.func.isRequired,
    loginStart: PropTypes.func.isRequired,
    loginSuccess: PropTypes.func.isRequired,
  };

  // eslint-disable-next-line class-methods-use-this
  componentDidMount() {
    recaptcha.initialize(config.GOOGLE_CAPTCHA_SITE_KEY);
  }

  render() {
    const { formFields, isLoading } = this.props;
    return (
      <EmailLoginForm
        formFields={formFields}
        isLoading={isLoading}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const { email } = getPropertiesFromQuery() || {};
const initialValues = {
  email,
};

/**
 * Adds field state and form validations to the login form
 */
export default stateForm(EmailLoginFormView, {
  initialValues,
  types: {
    email: FIELD_TYPES.EMAIL,
    password: FIELD_TYPES.PASSWORD,
  },
  validate: buildFormValidate({
    email: validEmail(),
    password: required(),
  }),
});
